// Module
var code = `<div class="s-multi-select-general-wrapper"> <div class="dropdown-placeholder"> <s-multi-select-general-input items="items" on-item-toggle="onItemToggle()" show-items-in-modal="showItemsInModal()" toggle-items-dropdown="toggleItemsDropdown()"/> <s-multi-select-general-items is-desktop ng-if="showDropdownList" items="items" on-item-toggle="onItemToggle()"/> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/common/directives/multiSelectGeneral/multiSelectGeneral.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;